// extracted by mini-css-extract-plugin
export default {"registerButtonArea":"UserList_registerButtonArea__1NxoI"};